import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mountain, Globe, BarChart3, Map, ShoppingBag, Heart, Compass, Sparkles, Users, Building2, Bike, Car, Presentation, FileText, Instagram, MessageCircle, Trees } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const pf = { fontFamily: "'Playfair Display', Georgia, serif" };

const SECTIONS = [
  {
    label: 'Collective 100 — The Fund',
    links: [
      { name: 'GoHimalayan × IHG — The Pitch', desc: 'A Himalayan brand within the IHG group · Collective 100 + a travel-experience portal · $18.5M (₹175 Cr) fund', path: '/links/ihg-pitch', icon: Presentation },
      { name: 'Collective 100 — Strategic Investor Pitch', desc: 'A $18.5M (₹175 Cr) fund opportunity · 100 host-driven Himalayan houses · for institutional partners', path: '/links/strategic-pitch', icon: Presentation },
    ],
  },
  {
    label: 'Announcement · GoHimalayan × OHSM',
    links: [
      { name: 'Joining Hands — Founders\u2019 Note', desc: 'Announcing our partnership · a peer-to-peer letter for owners of experiential Himalayan stays · downloadable PDF', path: '/founders-note', icon: Sparkles },
    ],
  },
  {
    label: 'Discover',
    links: [
      { name: 'Curated Stays', desc: 'Handpicked homestays across the Himalayas', path: '/discovered', icon: Mountain },
      { name: 'Itineraries', desc: 'Multi-day journeys — Spiti, Tirthan, Meghalaya, Kumaon', path: '/itineraries', icon: Compass },
      { name: 'AI Trip Planner', desc: 'Tell us your dream trip, we\'ll plan it', path: '/plan', icon: Sparkles },
      { name: 'Wishlist', desc: 'Your saved stays', path: '/wishlist', icon: Heart },
    ],
  },
  {
    label: 'Shop & Impact',
    links: [
      { name: 'The Himalayan Store', desc: '25+ artisan products — food, textiles, wellness', path: '/store', icon: ShoppingBag },
      { name: 'GoHimalayan Foundation', desc: 'Sustainability & capacity building in the Himalayas', path: '/impact', icon: Heart },
      { name: 'GoHimalayan Retail & Franchise', desc: 'Physical experience centres — Dubai & Canada', path: '/retail', icon: Building2 },
    ],
  },
  {
    label: 'Economy Engine — CM Pitches',
    links: [
      { name: 'Himachal Pradesh — The Himalayan Economy Engine', desc: '7-layer ecosystem pitch for the Chief Minister, HP', path: '/pitch/vision-himachal', icon: Globe },
      { name: 'Uttarakhand — The Himalayan Economy Engine', desc: '7-layer ecosystem pitch for the Chief Minister, UK', path: '/pitch/vision-uttarakhand', icon: Globe },
      { name: 'Meghalaya — The Himalayan Economy Engine', desc: '7-layer ecosystem pitch for the Chief Minister, MG', path: '/pitch/vision-meghalaya', icon: Globe },
    ],
  },
  {
    label: 'State Tech Partnerships (Dept. of Tourism)',
    links: [
      { name: 'Himachal Pradesh', desc: '20,000+ homestays — digitization pitch', path: '/pitch/himachal', icon: Globe },
      { name: 'Uttarakhand', desc: 'Uttarastays.com gap analysis — tech partner pitch', path: '/pitch/uttarakhand', icon: Globe },
      { name: 'Meghalaya', desc: '5,118 homestays — Northeast tourism pitch', path: '/pitch/meghalaya', icon: Globe },
    ],
  },
  {
    label: 'Brand Partnerships',
    links: [
      { name: 'Brand Partnership Program', desc: 'Co-curate Himalayan experiences with your brand', path: '/pitch/brands', icon: Presentation },
      { name: 'Royal Enfield × Spiti Circuit', desc: '7 days, 800 km — co-branded riding expedition', path: '/adventures/royal-enfield-spiti', icon: Bike },
      { name: 'Sonipat Drive Mahindra', desc: 'India\'s first dealership Himalayan experience', path: '/pitch/sonipat-drive', icon: Car },
    ],
  },
  {
    label: 'State Pages',
    links: [
      { name: 'Himachal Pradesh', path: '/states/himachal', icon: Map },
      { name: 'Uttarakhand', path: '/states/uttarakhand', icon: Map },
      { name: 'Meghalaya', path: '/states/meghalaya', icon: Map },
      { name: 'Ladakh', path: '/states/ladakh', icon: Map },
      { name: 'Sikkim', path: '/states/sikkim', icon: Map },
      { name: 'Arunachal Pradesh', path: '/states/arunachal', icon: Map },
      { name: 'Kashmir', path: '/states/kashmir', icon: Map },
      { name: 'Nagaland', path: '/states/nagaland', icon: Map },
      { name: 'Mizoram', path: '/states/mizoram', icon: Map },
      { name: 'Manipur', path: '/states/manipur', icon: Map },
      { name: 'Tripura', path: '/states/tripura', icon: Map },
      { name: 'Assam', path: '/states/assam', icon: Map },
      { name: 'West Bengal Hills', path: '/states/westbengal', icon: Map },
    ],
  },
  {
    label: 'For Hosts',
    links: [
      { name: 'Apply to be Featured', desc: '100 Himalayan homes. By invitation only. Free editorial listing.', path: '/apply', icon: Mountain },
      { name: 'Partner With Us', desc: 'List your homestay on GoHimalayan', path: '/partner', icon: Users },
      { name: 'Instagram Creatives', desc: 'Generate social media cards for your property', path: '/admin/social', icon: Instagram },
      { name: 'QR Code Generator', desc: 'Make printable QR codes for any GoHimalayan page', path: '/qr', icon: Sparkles },
    ],
  },
  {
    label: 'Corporate Decisions · Investment Board',
    links: [
      { name: 'GoHimalayan × OHSM — Investment Thesis', desc: 'Combined editorial + PMS stack · bundled pricing · B2G pitch · deal structure · gated', path: '/corporate/ohsm', icon: Presentation },
      { name: 'Host Bundle — Marketing PDF', desc: 'One-pager for property owners · your page + WhatsApp bookings + PMS + weekly social · downloadable PDF · CTA 98711 55963', path: '/host-offer', icon: FileText },
    ],
  },
  {
    label: 'Strategy · Internal',
    links: [
      { name: 'Business Plan & Tech Roadmap', desc: '90-day plan · revenue model · team allocation · Instagram engine · founder-eyes-only', path: '/business-plan', icon: Presentation },
      { name: '🚀 Launch Kit — 7 July', desc: 'One-click WhatsApp asset packs for all 100 hosts · QR · IG / FB / LinkedIn captions · sent tracker', path: '/admin/launch-kit', icon: Sparkles },
      { name: '🎯 Outreach Tracker', desc: 'Import Instagram following · shortlist · DM templates · auto-link incoming /apply submissions', path: '/admin/outreach', icon: Sparkles },
      { name: 'Lead Analytics', desc: 'Every WhatsApp click captured · attribution per stay / source / channel', path: '/admin/leads', icon: Presentation },
    ],
  },
  {
    label: 'Content Ops · Internal',
    links: [
      { name: 'Property Directory', desc: 'Live list of every active stay · host names · CTAs · auto-updated', path: '/directory', icon: BarChart3 },
      { name: 'Teaser Creative Generator', desc: 'Generate WhatsApp broadcast cards · 3 captions included', path: '/admin/teaser', icon: Instagram },
      { name: 'Phase 1 Content Push', desc: 'Bulk CSV ingest · Gemini Vision auto-audit · approve queue', path: '/admin/review', icon: FileText },
      { name: 'Run Data Pipeline', desc: 'Seeds + AI transform + publish · post-deploy refresh', path: '/admin/review', icon: Sparkles },
      { name: 'Admin Dashboard', desc: 'Suppliers · travelers · bookings · listings', path: '/admin', icon: Building2 },
      { name: 'Data Preview', desc: 'Hidden DB explorer · raw scraped + curated stays', path: '/admin/data', icon: BarChart3 },
    ],
  },
  {
    label: 'Legal & Info',
    links: [
      { name: 'About GoHimalayan', path: '/about', icon: Building2 },
      { name: 'Editorial Policy', path: '/editorial-policy', icon: FileText },
      { name: 'Privacy Policy', path: '/privacy', icon: FileText },
      { name: 'Terms of Service', path: '/terms', icon: FileText },
    ],
  },
];

export default function Links() {
  const [valleyGroups, setValleyGroups] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/valleys`)
      .then(r => r.json())
      .then(d => {
        const valleys = d.valleys || [];
        // Group by state, then sort within state by tier then name
        const byState = {};
        valleys.forEach(v => {
          if (!byState[v.state_slug]) byState[v.state_slug] = { name: '', items: [] };
          byState[v.state_slug].items.push(v);
        });
        // Get state display names from anchor_valleys structure (use first valley's state context if needed — fall back to slug)
        const stateOrder = [
          ['himachal-pradesh', 'Himachal Pradesh'],
          ['uttarakhand', 'Uttarakhand'],
          ['jk', 'Jammu & Kashmir'],
          ['ladakh', 'Ladakh'],
          ['sikkim', 'Sikkim'],
          ['west-bengal-hills', 'West Bengal Hills'],
          ['arunachal-pradesh', 'Arunachal Pradesh'],
          ['meghalaya', 'Meghalaya'],
          ['nagaland', 'Nagaland'],
          ['manipur', 'Manipur'],
          ['mizoram', 'Mizoram'],
          ['tripura', 'Tripura'],
          ['assam-himalayan', 'Assam Hills'],
        ];
        const groups = stateOrder
          .filter(([slug]) => byState[slug])
          .map(([slug, name]) => ({
            label: `${name} — Valleys`,
            links: byState[slug].items
              .sort((a, b) => (a.tier - b.tier) || a.name.localeCompare(b.name))
              .map(v => ({
                name: v.name,
                desc: v.stay_count
                  ? `${v.stay_count} ${v.stay_count === 1 ? 'stay' : 'stays'} · Tier ${v.tier}`
                  : `Tier ${v.tier} · editorial coming soon`,
                path: `/valley/${v.slug}`,
                icon: Trees,
              })),
          }));
        setValleyGroups(groups);
      })
      .catch(() => setValleyGroups([]));
  }, []);

  const allSections = [...SECTIONS, ...valleyGroups];
  return (
    <div className="min-h-screen bg-[#FAFAF8]" data-testid="links-page">
      {/* Header */}
      <div className="pt-12 pb-8 px-6 text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <Mountain className="w-7 h-7 text-[#2C5F8D]" />
          <span className="text-xl font-bold tracking-tight text-stone-800" style={pf}>GoHimalayan</span>
        </Link>
        <p className="text-stone-400 text-sm max-w-md mx-auto" style={pf}>Curated stays, itineraries, artisan products, and partnerships across the Indian Himalayas.</p>
      </div>

      {/* Links — masonry-balanced multi-column layout */}
      <div className="max-w-6xl mx-auto px-6 pb-16">
        <div
          className="lg:columns-3 sm:columns-2 columns-1 gap-x-6"
          style={{ columnFill: 'balance' }}
          data-testid="links-grid"
        >
          {allSections.map((section, si) => (
            <div key={si} className="break-inside-avoid mb-6">
              <p className="text-[10px] tracking-[0.3em] uppercase text-stone-400 font-semibold mb-2 px-1">{section.label}</p>
              <div className="space-y-2">
                {section.links.map((link, li) => (
                  <Link
                    key={li}
                    to={link.path}
                    className="flex items-center gap-3.5 bg-white rounded-xl border border-stone-100 px-4 py-3 hover:shadow-md hover:border-stone-200 transition-all group"
                    data-testid={`link-${link.path.replace(/\//g, '-').slice(1)}`}
                  >
                    <div className="w-9 h-9 rounded-lg bg-stone-50 flex items-center justify-center flex-shrink-0 group-hover:bg-[#2C5F8D]/10 transition-colors">
                      <link.icon className="w-4 h-4 text-stone-400 group-hover:text-[#2C5F8D] transition-colors" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-stone-800 group-hover:text-[#2C5F8D] transition-colors truncate">{link.name}</p>
                      {link.desc && <p className="text-[11px] text-stone-400 truncate">{link.desc}</p>}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}

          {/* WhatsApp tile */}
          <div className="break-inside-avoid mb-6">
            <p className="text-[10px] tracking-[0.3em] uppercase text-stone-400 font-semibold mb-2 px-1">Contact</p>
            <a href="https://wa.me/919871155963?text=Hi%20GoHimalayan!" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3.5 bg-[#25D366] rounded-xl px-4 py-3 hover:bg-[#1fb855] transition-colors" data-testid="link-whatsapp">
              <div className="w-9 h-9 rounded-lg bg-white/15 flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <p className="text-sm font-medium text-white">WhatsApp Us</p>
                <p className="text-[11px] text-white/60">+91 9871155963</p>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center pb-8">
        <p className="text-[10px] text-stone-300">© 2026 GoHimalayan · gohimalayan.com</p>
      </div>
    </div>
  );
}
